/** Turmas demo para o filtro obrigatório da lista de professores. */
export function buildDemoTeacherClasses() {
  return [
    {
      id: "FI-01-A",
      key: "FI-01-A1",
      name: "FI-01-A - Fund I 1A",
      period: "Manhã"
    },
    {
      id: "FI-01-B",
      key: "FI-01-B1",
      name: "FI-01-B - Fund I 1B",
      period: "Manhã"
    },
    {
      id: "FI-02-A",
      key: "FI-02-A1",
      name: "FI-02-A - Fund I 2A",
      period: "Tarde"
    }
  ];
}

/**
 * Lista de professores (Academics/teachers) — campos alinhados a `TeacherList`.
 * Um registro por professor; disciplinas agregadas em SDISCIPLINA_NOME.
 */
const DEMO_TEACHERS_BY_CLASS = {
  "FI-01-A": [
    {
      CODPROF: "1001",
      CODIGO: "1001",
      NOME: "Ana Paula Mendes",
      FUNCAO: "Professor",
      EMAIL: "ana.mendes@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "Português, Ciências"
    },
    {
      CODPROF: "1002",
      CODIGO: "1002",
      NOME: "Carlos Eduardo Souza",
      FUNCAO: "Professor",
      EMAIL: "carlos.souza@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "Matemática"
    },
    {
      CODPROF: "1003",
      CODIGO: "1003",
      NOME: "Mariana Costa Lima",
      FUNCAO: "Professor",
      EMAIL: "mariana.lima@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "Ciências"
    }
  ],
  "FI-01-B": [
    {
      CODPROF: "1004",
      CODIGO: "1004",
      NOME: "Roberto Alves Ferreira",
      FUNCAO: "Professor",
      EMAIL: "roberto.ferreira@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "História"
    },
    {
      CODPROF: "1005",
      CODIGO: "1005",
      NOME: "Juliana Rocha",
      FUNCAO: "Professor",
      EMAIL: "juliana.rocha@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "Inglês"
    }
  ],
  "FI-02-A": [
    {
      CODPROF: "1006",
      CODIGO: "1006",
      NOME: "Fernando Dias",
      FUNCAO: "Professor",
      EMAIL: "fernando.dias@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "Matemática"
    },
    {
      CODPROF: "1007",
      CODIGO: "1007",
      NOME: "Patrícia Nunes",
      FUNCAO: "Professor",
      EMAIL: "patricia.nunes@colegio.com",
      FOTO_URL: "",
      SDISCIPLINA_NOME: "Português"
    }
  ]
};

function withId(t) {
  return {
    ...t,
    id: t.CODPROF
  };
}

/**
 * @param {string} searchText
 * @param {string} classId — código da turma (obrigatório)
 */
export function buildDemoTeachersList(searchText = "", classId = "") {
  if (!classId) return [];

  let list = (DEMO_TEACHERS_BY_CLASS[classId] || []).map(withId);
  const s = String(searchText || "")
    .trim()
    .toLowerCase();
  if (s.length > 0) {
    list = list.filter(t => t.NOME.toLowerCase().includes(s));
  }
  return list;
}

/**
 * @param {string} id — CODPROF
 */
export function buildDemoTeacher(id) {
  const all = Object.values(DEMO_TEACHERS_BY_CLASS)
    .flat()
    .map(withId);
  return (
    all.find(
      t => String(t.CODPROF) === String(id) || String(t.id) === String(id)
    ) || null
  );
}

export function buildDemoClassesForTeacher(codProf) {
  const classes = [];
  Object.entries(DEMO_TEACHERS_BY_CLASS).forEach(([classId, teachers]) => {
    if (teachers.some(t => String(t.CODPROF) === String(codProf))) {
      const meta = buildDemoTeacherClasses().find(c => c.id === classId);
      if (meta) classes.push(meta);
    }
  });
  return classes;
}
